import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-0 right-0 flex items-center justify-center w-5 h-5 bg-accent text-primary-foreground text-xs font-bold rounded-full"
}

import { ref } from 'vue';
import { useCartStore } from '@/stores/cartStore';
import ShoppingCartFloating from '@/components/cart/ShoppingCartFloating.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShoppingCartButton',
  setup(__props) {

const cartStore = useCartStore();
const isOpen = ref(false);

const toggleCart = () => {
  isOpen.value = !isOpen.value;
};

const closeCart = () => {
  isOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "relative p-2 text-gray-400 hover:text-primary transition-colors rounded-lg hover:bg-primary/10",
      "aria-label": "Shopping cart",
      onClick: toggleCart
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: ['fal', 'shopping-cart'],
        class: "text-2xl"
      }),
      (_unref(cartStore).itemCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(cartStore).itemCount > 99 ? '99+' : _unref(cartStore).itemCount), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ShoppingCartFloating, {
      "is-open": isOpen.value,
      onClose: closeCart
    }, null, 8, ["is-open"])
  ]))
}
}

})